import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';

/**
 * Toasts replace the Django `messages` framework banners. Styling is driven off
 * the same tokens as the rest of the console so dark mode works without a
 * separate theme prop.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            'group rounded-lg border border-line bg-surface text-ink shadow-pop text-[13px] gap-2',
          description: 'text-ink-3 text-xs',
          actionButton: 'bg-primary text-primary-contrast rounded px-2 py-1 text-xs',
          cancelButton: 'bg-surface-muted text-ink-2 rounded px-2 py-1 text-xs',
          error: 'border-danger/40 [&_[data-icon]]:text-danger',
          success: '[&_[data-icon]]:text-positive',
          warning: '[&_[data-icon]]:text-warn',
          info: '[&_[data-icon]]:text-info',
        },
      }}
    />
  );
}

export const toast = sonnerToast;

/** Consistent failure toast for mutations, using the server's message. */
export function toastError(error: unknown, fallback = 'Something went wrong.') {
  const message = error instanceof Error && error.message ? error.message : fallback;
  sonnerToast.error(message);
}
